import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

export function CopyButton({ value, label = "Kopiuj", size = "sm", className = "d-flex align-items-center p-2" }) {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async (text) => {
    const value = String(text ?? "");
    if (!value) return false;

    try {
        await navigator.clipboard.writeText(value);
        return true;
    } catch (e) {
        try {
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        return ok;
        } catch {
        return false;
        }
    }
    };

  const handleCopy = async () => {
    const ok = await copyToClipboard(value);
    if (!ok) return;

    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{copied ? "Skopiowano!" : "Kliknij, aby skopiować"}</Tooltip>}
    >
      <Button
        variant={copied ? "success" : "outline-secondary"}
        size={size}
        className={className}
        onClick={handleCopy}
        disabled={!value}
      >
        <i className={copied ? "fas fa-check mr-1" : "far fa-copy mr-1"} />
        {copied ? "Kopiuj" : label}
      </Button>
    </OverlayTrigger>
  );
}